import { sendEvent } from "../services/AnalyticsService";
import { purifyMarkup } from "../services/DomPurifyService";
import { get } from "../services/http";
import routeListen from "../services/routeListen";

interface keyValueObject {
    [key:string]:string
}

export function urlEncode(object: keyValueObject): URLSearchParams {
    const urlencoded = new URLSearchParams();
    const keys = Object.keys(object)
    for (const key of keys) {
        urlencoded.append(key, object[key])
    }
    return urlencoded
}

export function getParsedJwt(token: string): {exp: number} | undefined {
    try {
      return JSON.parse(atob(token.split('.')[1]))
    } catch {
      return undefined
    }
}

export function downloadFile(url: string, filename?: string) {

    const link = document.createElement("a");
    link.href = purifyMarkup(url);
    link.download = filename ? purifyMarkup(filename) : `download-${new Date()}`;
    document.body.appendChild(link);
                           
    link.dispatchEvent(
        new MouseEvent('click', { 
            bubbles: true, 
            cancelable: true, 
            view: window 
    }));
                            
    // Remove link from body
    document.body.removeChild(link);
}

export function getBaseURL(env: string | null, featureName?:string): string {
    switch(env) {
        case 'QA':
            return `https://api.tab-qa.com/`;
        case 'Production':
            return `https://api.theappbuilder.com/`;
        case 'Local':
            return `https://api.tab-dev.com/`;
        case 'Development':
            return `https://api.${featureName ?? process.env.FEATURENAME}.tab-feature.com/`
        case 'Dev':
            return `https://api.tab-dev.com/`
        default:
            return '$__{DevApiUrl}__$';
    }
}

export function setHttp(link:string) {
    if (link.search(/^http[s]?:\/\//) == -1) {
        link = 'http://' + link;
    }
    return link;
}

export function getHeaders(dateString: string){
    return {headers: {"If-Modified-Since": dateString}}
}

export function formatQueryParams(url: URL) {
    return new Proxy(new URLSearchParams(url.search), {
        get: (searchParams, prop: string) => searchParams.get(prop),
    });
}


export function  openInNewTab(href: string) {
    Object.assign(document.createElement('a'), {
        target: '_blank',
        rel: 'noopener noreferrer',
        href: href,
    }).click();
}

export async function handleOpenWeb(id, type, text){
    sendEvent('view', {overrideProps:{
        contentId: id,
        contentType: type,
        contentTitle: text
    }})

    const {data} = await  get(`api/app/${routeListen.appGuid()}/content/${id}`);

    openInNewTab(data.webUrl)
}